import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const PortletToolbar = props => {
  const { className, children, sx, ...rest } = props;

  const baseSx = { justifyContent: 'flex-end', alignItems: 'center', display: 'flex' };

  return (
    <Box {...rest} className={className} sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Box>
  );
};

PortletToolbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

PortletToolbar.defaultProps = {
  children: undefined,
  className: 'portlet-toolbar',
  sx: undefined,
};

export default PortletToolbar;
